import React from "react";
import { Route, Routes, BrowserRouter as Router } from "react-router-dom";
import Screens from './screen';
import ILogin from './internal/ipages/ilogin';
import IDashboard from './internal/ipages/ihomepage';
import IClient from './internal/ipages/iclient-list';
import IClientForm from './internal/ipages/iclient-form';
import IClientDetail from './internal/ipages/iclient-detail';
import IClientLicence from './internal/ipages/iclient-licence';
import IReqRenewLicence from './internal/ipages/ireqrenewlicence-list';
import IReqAddLicence from './internal/ipages/ireqaddlicence-list';
import IReqClaimGCP from './internal/ipages/ireqclaimgcp-list';
import IReqUpgradeLicence from './internal/ipages/irequpgrade-list';
import IReqTraining from './internal/ipages/ireqtraining-list';
import ILicencesExpired from './internal/ipages/ilicenceexp-list';
import ILicencesType from './internal/ipages/ilicencetype-list';
import IAddContents from './internal/ipages/iaddcontent-list';
import IAddContentsForm from './internal/ipages/iaddcontent-form';
import IAddContentsDetail from './internal/ipages/iaddcontent-detail';
import IClientMessages from './internal/ipages/iclientmessage-list';
import IClientChatHistory from './internal/ipages/iclientchathistory-list';
import IMyProfiles from './internal/ipages/imyprofile';
import IZTEForm from './internal/ipages/izte-form';
import IZTElog from './internal/ipages/izte-log-list';
import IZTEFormDel from './internal/ipages/izte-formdel';
import ILogNotification from './internal/ipages/inotificationlog-list';
import ILogNotifDetail from './internal/ipages/inotificationlog-detail';
import IMember from './internal/ipages/imember-list';
import IMemberForm from './internal/ipages/imember-form';
import IMemberSetForm from './internal/ipages/imember-set-form';
import ISExtDrive from './internal/ipages/iextdrive-list';
import ISendNotification from './internal/ipages/inotificationsend-list';
import ISendNotifDetail from './internal/ipages/inotificationsend-detail';
import IGCPBudgets from './internal/ipages/igcpbudget-list';
import IGCPBudgetsForm from './internal/ipages/igcpbudget-form';
import IGCPBudgetsDetail from './internal/ipages/igcpbudget-detail';
import IGCPBudgetsMsgTemplate from './internal/ipages/igcpbudget-msgtemplate-form';

import CUCPage from './customer/cpages/cunderconstruction';
import CLogin from './customer/cpages/clogin';
import CDashboard from './customer/cpages/chomepage';
import CMyProfiles from './customer/cpages/cmyprofile';
import CNewsList from './customer/cpages/cnews-list';
import CNewsDetail from './customer/cpages/cnews-detail';
import CAbout from './customer/cpages/cabout';
import CReqAddLicence from './customer/cpages/creqaddlicence-form';
import CReqClaim from './customer/cpages/creqclaim-form';
import CReqUpgrade from './customer/cpages/crequpgrade-form';
import CReqTraining from './customer/cpages/creqtraining-form';
import CReqRenewLicence from './customer/cpages/creqrenew-form';
import CContact from './customer/cpages/ccontact';
import CRequestList from './customer/cpages/crequest-list';

import CAppNewsDetail from './customer/cpages/cappnews-detail';

import ITestDemo from './internal/ipages/testdemoapi';
import IAddTestDemo from './internal/ipages/testdemoapi-form';

import ITestDemoThankyouBot from './internal/ipages/testdemo-thankyoubot';
import IAddTestDemoThankyouBot from './internal/ipages/testdemo-thankyoubot-form';

// import ITest from './internal/ipages/testpage';
// import ITestDrive from './internal/ipages/testdrive';

const App = () => {
  
  var mainPage = <Screens />;
  var homePage = <ILogin />;
  var clientPage = <ILogin />, addclientPage = <ILogin />, renewPage = <ILogin />, addlicencePage = <ILogin />, licenceexpPage = <ILogin />, licencetypePage = <ILogin />, detailclientPage = <ILogin />, licenceclientPage = <ILogin />; 
  var claimPage = <ILogin />, upgradePage = <ILogin />, trainingPage = <ILogin />;
  var clientmessagePage = <ILogin />, clientchathistPage = <ILogin />;
  var addcontentPage = <ILogin />, addnewcontentPage = <ILogin />, detailaddcontentPage = <ILogin />;
  var myprofilePage = <ILogin />, memberPage = <ILogin />, addmemberPage = <ILogin />, setmemberPage = <ILogin />;
  var logNotification = <ILogin />, detaillognotifPage = <ILogin />, sendnotificationPage = <ILogin />, detailsendnotifPage = <ILogin />;
  var ztePage = <ILogin />, ztelogPage = <ILogin />, ztedelPage = <ILogin />;
  var myextdrivePage = <ILogin />;
  var gcpbudgetPage=<ILogin />, addgcpbudgetPage=<ILogin />, detailgcpbudgetPage=<ILogin />;
  var msgtemplategcpbudgetPage=<ILogin />;

  var custhomePage = <CLogin />;
  var custnewsPage = <CLogin />, custnewsdetailPage= <CLogin />; 
  var custaddlicencePage = <CLogin />;
  var custclaimPage = <CLogin />;
  var custupgradePage = <CLogin />;
  var custreqtrainingPage = <CLogin />;
  var custrenewlicencePage = <CLogin />;
  var custcontactPage = <CLogin />;
  var custmyprofilePage = <CLogin />;
  var custaboutPage = <CLogin />;
  var custrequestlistPage = <CLogin />;

  var custappnewsdetailPage = <CLogin />;

  var sessionUID = '';
  // --- ONLINE --------------
  var hostName = window.location.hostname;
  // --- LOCALHOST --------------
  var currentURL = window.location.pathname;
  var arrPath = currentURL.split('/');
  
  
  var portalname = "";
  if(hostName === 'customers.point-star.com') { portalname = "customerportal"; }
  else if(hostName === 'internal.point-star.com') { portalname = "internalportal"; }
  else {
    if(arrPath[1] !== "") {
      if(arrPath[1].toLowerCase() === "customerportal") { portalname = "customerportal"; }
      else if(arrPath[1].toLowerCase() === "internalportal") { portalname = "internalportal"; }
      else {
        if(arrPath[1].toLowerCase().substring(0,1) === "c") { portalname = "customerportal"; }
        else if(arrPath[1].toLowerCase().substring(0,1) === "i") { portalname = "internalportal"; }
      }
    }
  }
  // console.log("portal name : ", portalname);
  // console.log("cust id: ", localStorage.getItem('cuid'));
  // console.log("int id: ", localStorage.getItem('uid'));
  if(portalname === "customerportal") {
    if(localStorage.getItem('cuid') !== null) { 
      sessionUID = localStorage.getItem('cuid'); 
      mainPage =<CDashboard />;
    } else {
      sessionUID = "";
      mainPage =<CLogin />;
    }
  } else if(portalname === "internalportal") {
    if(localStorage.getItem('uid') !== null) { 
      sessionUID = localStorage.getItem('uid'); 
      mainPage =<IDashboard />;
    } else {
      sessionUID = "";
      mainPage = <ILogin />;
    }
  } else {
    localStorage.clear();
  }
  // console.log("sess id: ", sessionUID);

  if(sessionUID !== '') { 
    homePage=<IDashboard />;
    memberPage=<IMember />;
    addmemberPage=<IMemberForm />;
    setmemberPage=<IMemberSetForm />;
    clientPage=<IClient />;
    addclientPage=<IClientForm />;
    detailclientPage=<IClientDetail />;
    licenceclientPage=<IClientLicence />;
    renewPage=<IReqRenewLicence />;
    addlicencePage=<IReqAddLicence />;
    claimPage=<IReqClaimGCP />;
    upgradePage=<IReqUpgradeLicence />;
    trainingPage=<IReqTraining />;
    licenceexpPage=<ILicencesExpired />;
    licencetypePage=<ILicencesType />;
    addcontentPage=<IAddContents />;
    addnewcontentPage=<IAddContentsForm />;
    detailaddcontentPage=<IAddContentsDetail />;
    clientmessagePage=<IClientMessages />;
    clientchathistPage=<IClientChatHistory />;
    myprofilePage=<IMyProfiles />;
    logNotification=<ILogNotification />;
    detaillognotifPage=<ILogNotifDetail />;
    myextdrivePage=<ISExtDrive />;
    sendnotificationPage=<ISendNotification />;
    detailsendnotifPage=<ISendNotifDetail />;
    gcpbudgetPage=<IGCPBudgets />;
    addgcpbudgetPage=<IGCPBudgetsForm />;
    detailgcpbudgetPage=<IGCPBudgetsDetail />;
    msgtemplategcpbudgetPage = <IGCPBudgetsMsgTemplate />;

    ztePage = <IZTEForm />;
    ztelogPage = <IZTElog />;
    ztedelPage = <IZTEFormDel />;
    
    custhomePage=<CDashboard />;
    custnewsPage = <CNewsList />; 
    custnewsdetailPage = <CNewsDetail />;
    custaddlicencePage = <CReqAddLicence />;
    custclaimPage = <CReqClaim />;
    custupgradePage = <CReqUpgrade />;
    custreqtrainingPage = <CReqTraining />;
    custrenewlicencePage = <CReqRenewLicence />;
    custcontactPage = <CContact />;
    custmyprofilePage = <CMyProfiles />;
    custaboutPage = <CAbout />;
    custrequestlistPage = <CRequestList />;

    custappnewsdetailPage = <CAppNewsDetail />;

  } 
  return (
    <>
     
        <Router>
          
          <div >
          <Routes>
            <Route exact path='/' element={mainPage}></Route>
            <Route path='internalportal' element={homePage}></Route>
            <Route path='customerportal' element={custhomePage}></Route>


            <Route path="/iclients" element={clientPage}></Route>
            <Route path="/iaddclients" element={addclientPage}></Route>
            <Route path="/ieditclients/:id" element={addclientPage}></Route>
            <Route path="/iviewclients/:id" element={detailclientPage}></Route>
            
            <Route path="/iviewlicence/:id/:licid" element={licenceclientPage}></Route>
            
            <Route path="/irenewlicence" element={renewPage}></Route>
            <Route path="/iaddlicence" element={addlicencePage}></Route>
            <Route path="/iclaimgcp" element={claimPage}></Route>
            <Route path="/iupgradelicence" element={upgradePage}></Route>
            <Route path="/itraining" element={trainingPage}></Route>
            <Route path="/ilicenceexpired" element={licenceexpPage}></Route>
            <Route path="/ilicencetypes" element={licencetypePage}></Route>
            <Route path="/iclientmessages" element={clientmessagePage}></Route>
            <Route path="/iclientchathistory" element={clientchathistPage}></Route>
            
            <Route path="/iaddcontent" element={addcontentPage}></Route>
            <Route path="/iaddnewcontent" element={addnewcontentPage}></Route>
            <Route path="/ieditaddcontent/:id" element={addnewcontentPage}></Route>
            <Route path="/iviewaddcontent/:id" element={detailaddcontentPage}></Route>
            
            <Route path="/izte" element={ztePage}></Route>
            <Route path="/iztelog" element={ztelogPage}></Route>
            <Route path="/iztedel" element={ztedelPage}></Route>
            
            <Route path="/ilognotification" element={logNotification}></Route>
            <Route path="/iviewlognotif/:id" element={detaillognotifPage}></Route>
            <Route path="/isendnotification" element={sendnotificationPage}></Route>
            <Route path="/iviewsendnotif/:id" element={detailsendnotifPage}></Route>

            <Route path="/imembers" element={memberPage}></Route>
            <Route path="/iaddmembers" element={addmemberPage}></Route>
            <Route path="/ieditmembers/:id" element={addmemberPage}></Route>
            <Route path="/iviewmembers/:id" element={addmemberPage}></Route>
            <Route path="/isetmembers/:id" element={setmemberPage}></Route>

            <Route path="/imyprofile" element={myprofilePage}></Route>

            <Route path="/iextdrive" element={myextdrivePage}></Route>
            
            <Route path="/igcpbudget" element={gcpbudgetPage}></Route>
            <Route path="/iaddgcpbudget" element={addgcpbudgetPage}></Route>
            <Route path="/ieditgcpbudget/:id" element={addgcpbudgetPage}></Route>
            <Route path="/iviewgcpbudget/:id" element={detailgcpbudgetPage}></Route>
            <Route path="/igcpbudgetmsgtemplate" element={msgtemplategcpbudgetPage}></Route>
            
            <Route path="/cuc" element={CUCPage}></Route>

            <Route path="/chome" element={custhomePage}></Route>
            <Route path="/cnews/:type" element={custnewsPage}></Route>
            <Route path="/cnewsview/:id" element={custnewsdetailPage}></Route>
            <Route path="/caddlicence" element={custaddlicencePage}></Route>
            <Route path="/cclaim" element={custclaimPage}></Route>
            <Route path="/cupgrade" element={custupgradePage}></Route>
            <Route path="/creqtraining" element={custreqtrainingPage}></Route>
            <Route path="/crenewlicence" element={custrenewlicencePage}></Route>
            <Route path="/ccontact" element={custcontactPage}></Route>
            <Route path="/cmyprofile" element={custmyprofilePage}></Route>
            <Route path="/cabout" element={custaboutPage}></Route>
            <Route path="/clogin" element={custhomePage}></Route>

            <Route path="/cviewaddlicence" element={custrequestlistPage}></Route>
            <Route path="/cviewclaim" element={custrequestlistPage}></Route>
            <Route path="/cviewupgrade" element={custrequestlistPage}></Route>
            <Route path="/cviewreqtraining" element={custrequestlistPage}></Route>
            <Route path="/cviewrenewlicence" element={custrequestlistPage}></Route>
            
            <Route path="/cappnewsview" element={custappnewsdetailPage}></Route>
            
            {/* ===== Start - FOR DEMO APPSHEET ======== */}
            <Route path="/TestDemoAppsheet" element={<ITestDemo />}></Route>
            <Route path="/TestAddDemoAppsheet" element={<IAddTestDemo />}></Route>
            <Route path="/TestEditDemoAppsheet" element={<IAddTestDemo />}></Route>
            {/* ===== End - FOR DEMO APPSHEET ======== */}
            {/* ===== Start - FOR DEMO THANKYOU CHATBOT ======== */}
            <Route path="/demothankyoubot" element={<ITestDemoThankyouBot />}></Route>
            <Route path="/demothankyouform" element={<IAddTestDemoThankyouBot />}></Route>
            {/* ===== END - FOR DEMO THANKYOU CHATBOT ======== */}
            {/* <Route path="/Test" element={<ITest />}></Route>
            <Route path="/TestDrive" element={<ITestDrive />}></Route> */}

            
          </Routes>
          </div>
          
        </Router>
        
    </>
  );
};

export default App;
